import React from "react";

const FooterLogos = () => {
  return (
    <div className="flex items-center justify-center gap-4">
      <img
        src="/images/ministry logo light.png"
        alt="Ministry of Administrative Development Logo"
        className="md:h-[100px] h-[60px] w-auto my-8 md:my-0"
        loading="lazy"
        decoding="async"
      />
      <img
        src="/images/bunat-light.png"
        alt="Bunaa Logo"
        className="md:h-[90px] h-[50px] w-auto my-8 md:my-0"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};

export default FooterLogos;